// apps/web/src/config/environment.ts

interface ImportMetaEnv {
  readonly VITE_API_URL?: string;
  // Все остальные VITE_* переменные удалены, так как не используются
}

interface WindowWithEnv extends Window {
  __ENV__?: Record<string, string | undefined>;
}

// Определяем источник: в development используем import.meta.env, в production – window.__ENV__
const isDevelopment = import.meta.env.DEV || process.env.NODE_ENV === 'development';

function getEnvVar(key: string): string | undefined {
  if (isDevelopment) {
    // Vite пробрасывает переменные из .env в import.meta.env
    return (import.meta.env as ImportMetaEnv)[key as keyof ImportMetaEnv];
  } else {
    // В продакшене берём из глобального объекта, подставленного entrypoint'ом
    return (window as WindowWithEnv).__ENV__?.[key];
  }
}

export const environment = {
  production: !isDevelopment,
  apiBaseUrl: getEnvVar('VITE_API_URL') || 'http://localhost:8080',
  // Остальные поля удалены
};

export type Environment = typeof environment;
